import { getLogger } from '../logger';

const logger = getLogger('modal-container');

export const initialModalsState = {
  openModalsList: [],
  modalsList: [],
};

export const modalDialogReducer = (state, action) => {
  const { modalsList } = state;
  const isIdProvided = !!action.payload.id;
  const isRegisteredinModalList = Object.keys(modalsList).includes(action.payload.id);
  const indexInOpenModals = state.openModalsList.findIndex((modal) => modal.id === action.payload.id);

  switch (action.type) {
    case 'show-modal':
      if (!isIdProvided) {
        logger.warn('Id of modal to be shown has not been provided');
        return state;
      }
      if (!isRegisteredinModalList) {
        logger.warn(`Modal with id ${action.payload.id} is not registered in Modals List`);
        return state;
      }
      if (indexInOpenModals !== -1) {
        logger.warn(`Modal with id '${action.payload.id}' is already open`);
        return state;
      }
      return {
        ...state,
        openModalsList: [
          ...state.openModalsList,
          action.payload,
        ],
      };
    case 'hide-modal':
    default:
      if (!isIdProvided) {
        logger.warn('Id of modal has not been provided to hide');
        return state;
      }
      if (action?.payload?.id) {
        return {
          ...state,
          openModalsList: state.openModalsList.filter((openModal) => openModal.id !== action?.payload?.id),
        };
      }
      // Hide the last opened modal
      return {
        ...state,
        openModalsList: state.openModalsList.slice(0, -1),
      };
  }
};
